import dayjs from "dayjs"

export function isLockedTransaction(isLockEnabled: boolean, transactionDate: string, lockEndDate: string | null) {
  return isLockEnabled && dayjs(transactionDate) < dayjs(lockEndDate)
}
